import { styleReset } from 'react95';
import { createGlobalStyle } from 'styled-components';
import ms_sans_serif from 'react95/dist/fonts/ms_sans_serif.woff2';
import ms_sans_serif_bold from 'react95/dist/fonts/ms_sans_serif_bold.woff2';

export const GlobalStyles = createGlobalStyle`
@font-face {
  font-family: 'ms_sans_serif';
  src: url(${ms_sans_serif}) format('woff2');
  font-weight: 400;
  font-style: normal
}
@font-face {
  font-family: 'ms_sans_serif';
  src: url(${ms_sans_serif_bold}) format('woff2');
  font-weight: bold;
  font-style: normal
}
* {
  background-color: #C6C6C6;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

${styleReset}
`;
